import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { IExtensionService } from 'vscode/vscode/vs/workbench/services/extensions/common/extensions.service';
import { IProgressService } from 'vscode/vscode/vs/platform/progress/common/progress.service';
import { localizeWithPath } from 'vscode/vscode/vs/nls';
import { DeferredPromise, timeout } from 'vscode/vscode/vs/base/common/async';
import { ILogService } from 'vscode/vscode/vs/platform/log/common/log.service';
import { CancellationToken } from 'vscode/vscode/vs/base/common/cancellation';

const _moduleId = "vs/workbench/contrib/extensions/browser/extensionsActivationProgress";
let ExtensionActivationProgress = class ExtensionActivationProgress {
    constructor(extensionService, progressService, logService) {
        const options = {
            location: 10 ,
            title: ( localizeWithPath(_moduleId, 0, "Activating Extensions..."))
        };
        let deferred;
        let count = 0;
        this._listener = extensionService.onWillActivateByEvent(e => {
            logService.trace('onWillActivateByEvent: ', e.event);
            if (!deferred) {
                deferred = ( (new DeferredPromise()));
                progressService.withProgress(options, _ => deferred.p);
            }
            count++;
            Promise.race([e.activation, timeout(5000, CancellationToken.None)]).finally(() => {
                if (--count === 0) {
                    deferred.complete(undefined);
                    deferred = undefined;
                }
            });
        });
    }
    dispose() {
        this._listener.dispose();
    }
};
ExtensionActivationProgress = ( (__decorate([
    ( (__param(0, IExtensionService))),
    ( (__param(1, IProgressService))),
    ( (__param(2, ILogService)))
], ExtensionActivationProgress)));

export { ExtensionActivationProgress };
